/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountResource
 */
export interface AccountResource {
    /**
     * 
     * @type {string}
     * @memberof AccountResource
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountResource
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountResource
     */
    photoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountResource
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountResource
     */
    deleted?: boolean;
}

/**
 * Check if a given object implements the AccountResource interface.
 */
export function instanceOfAccountResource(value: object): value is AccountResource {
    return true;
}

export function AccountResourceFromJSON(json: any): AccountResource {
    return AccountResourceFromJSONTyped(json, false);
}

export function AccountResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountResource {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'email': json['email'] == null ? undefined : json['email'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
    };
}

export function AccountResourceToJSON(value?: AccountResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'photoUrl': value['photoUrl'],
        'email': value['email'],
        'deleted': value['deleted'],
    };
}

